import { render, staticRenderFns } from "./Unilabs.vue?vue&type=template&id=2629ff74&"
import script from "./Unilabs.vue?vue&type=script&lang=js&"
export * from "./Unilabs.vue?vue&type=script&lang=js&"
import style0 from "./Unilabs.vue?vue&type=style&index=0&id=2629ff74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports